import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { FieldErrors } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { SIGN_IN } from 'features/user/api/mutations/signIn'
import { SignInData, SignInVars } from 'features/user/api/types/signIn'
import { Schema } from 'features/user/forms/UserLoginForm/schema'
import { mapGraphQLErrors } from 'providers/tanstack-query/errors'
import { useMutation } from 'providers/tanstack-query/useMutation'
import { useAuthenticate } from '../useAuthenticate'
import { UseSignIn } from './types'

export const useSignIn = (): UseSignIn => {
  const { t } = useTranslation('features/user')
  const { authenticate } = useAuthenticate()
  const { enqueueSnackbar } = useSnackbar()
  const [errors, setErrors] = useState<FieldErrors<SignInVars>>({})

  const { isPending, mutateAsync } = useMutation<SignInVars, SignInData>({
    mutation: SIGN_IN,
    onCompleted: async data => {
      const {
        signIn: { accessToken, errors, refreshToken, user },
      } = data

      if (errors && errors.length > 0) {
        setErrors(mapGraphQLErrors(errors))
      } else if (accessToken && refreshToken && user) {
        setErrors({})
        authenticate({ accessToken, refreshToken, user })
        enqueueSnackbar(t('login.success'), { variant: 'success' })
      }
    },
  })

  const signIn = (variables: Schema): void => {
    void mutateAsync(variables satisfies SignInVars)
  }

  return {
    errors,
    loading: isPending,
    signIn,
  }
}
